import { ActionTree, ActionContext } from 'vuex';

import { ToastStateI } from './state';
import { RootStateI } from '../state';

const actions: ActionTree<ToastStateI, RootStateI> = {
  showToast(context: ActionContext<ToastStateI, RootStateI>, payload: ToastStateI) {
    context.commit('setToast', payload);
  },
  closeToast(context: ActionContext<ToastStateI, RootStateI>) {
    context.commit('closeToast');
  },
  success(context: ActionContext<ToastStateI, RootStateI>, message: string) {
    context.commit('setToast', {
      message,
      type: 'success',
      show: true,
    });
  },
  error(context: ActionContext<ToastStateI, RootStateI>, message: string) {
    context.commit('setToast', {
      message,
      type: 'error',
      show: true,
    });
  },
};

export default actions;
